(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ch-hero-slider')) {
    class ChHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ch-track]');
        if (!this.track || this.track.children.length < 2) return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.prev = this.querySelector('[data-ch-prev]');
        this.next = this.querySelector('[data-ch-next]');
        this.dots = Array.from(this.querySelectorAll('[data-ch-dot]'));
        this.prev?.addEventListener('click', () => this.go(this.index() - 1), { signal });
        this.next?.addEventListener('click', () => this.go(this.index() + 1), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.chDot)), { signal }));
        this.track.addEventListener('scroll', () => this.queue(), { passive: true, signal });
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      index() {
        const width = this.track.clientWidth || 1;
        return Math.round(Math.abs(this.track.scrollLeft) / width);
      }

      go(target) {
        const count = this.track.children.length;
        const index = Math.max(0, Math.min(count - 1, target));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollTo({ left: direction * index * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      queue() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const current = this.index();
        const count = this.track.children.length;
        this.dots.forEach((dot, i) => {
          if (i === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.prev) this.prev.disabled = current === 0;
        if (this.next) this.next.disabled = current >= count - 1;
      }
    }
    customElements.define('ch-hero-slider', ChHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
